import React from "react";
import { Button, Tooltip } from "antd";
import {
    CompressOutlined,
    PrinterOutlined,
    RedoOutlined,
    OneToOneOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
} from "@ant-design/icons";

type Props = {
    canInteract: boolean;
    onPrintGraph: () => void;
    onReloadGraph: () => void;
    onZoom: (factor: number | string) => void;
};

const TaskStatusFlowScaleToolbar: React.FC<Props> = ({
    canInteract,
    onPrintGraph,
    onReloadGraph,
    onZoom,
}) => (
    <div className="flow-scale-toolbar">
        <Tooltip title="Print graph" placement="left">
            <Button
                className="x6-toolbar-item xflow-toolbar-item"
                disabled={!canInteract}
                onClick={onPrintGraph}
            >
                <PrinterOutlined />
            </Button>
        </Tooltip>
        <Tooltip title="Reload graph" placement="left">
            <Button
                className="x6-toolbar-item xflow-toolbar-item"
                disabled={!canInteract}
                onClick={onReloadGraph}
            >
                <RedoOutlined />
            </Button>
        </Tooltip>
        <Tooltip title="Zoom in" placement="left">
            <Button
                className="x6-toolbar-item xflow-toolbar-item"
                disabled={!canInteract}
                onClick={() => onZoom(0.1)}
            >
                <ZoomInOutlined />
            </Button>
        </Tooltip>
        <Tooltip title="Zoom out" placement="left">
            <Button
                className="x6-toolbar-item xflow-toolbar-item"
                disabled={!canInteract}
                onClick={() => onZoom(-0.1)}
            >
                <ZoomOutOutlined />
            </Button>
        </Tooltip>
        <Tooltip title="Zoom to 1:1" placement="left">
            <Button
                className="x6-toolbar-item xflow-toolbar-item"
                disabled={!canInteract}
                onClick={() => onZoom("real")}
            >
                <OneToOneOutlined />
            </Button>
        </Tooltip>
        <Tooltip title="Fit screen" placement="left">
            <Button
                className="x6-toolbar-item xflow-toolbar-item"
                disabled={!canInteract}
                onClick={() => onZoom("fit")}
            >
                <CompressOutlined />
            </Button>
        </Tooltip>
    </div>
);

export default TaskStatusFlowScaleToolbar;
